module.exports = __webpack_public_path__ + "static/media/Password.63ecf245.svg";